import { useEffect, useRef, useState } from "react";
import { useViewport } from "/src/components/hooks/viewport";

function ResponsiveContainer({ children, className, marginBottom=0, ...otherProps }) {

  const ref = useRef();
  const viewport = useViewport();

  const [rect, setRect] = useState();
  const [height, setHeight] = useState();

  useEffect(() => {
    // Only run once on mount
    const rect = ref.current.getBoundingClientRect();
    setRect(rect);
  }, [ref.current]);

  useEffect(() => {
    if (viewport && rect) {
      const height = viewport.height - rect.top - marginBottom;
      setHeight(height);
    }
  }, [viewport, rect]);

  otherProps.style = otherProps.style || {};
  // otherProps.style.marginBottom = marginBottom;

  const renderChildren = () => {
    if (height) {
      return children;
    }
  }

  className = (className || "") + " d-flex flex-column";
  return (
    <div {...otherProps} className={className} ref={ref} style={{ ...otherProps.style, height: height }}>
      {renderChildren()}
    </div>
  );

}

export default ResponsiveContainer;
